export default "__VITE_ASSET__de297cc2__$_?react__"